function processMessage(message) {
    if (!message || typeof message !== 'object') {
        return message;
    }

    const errorArray = message.errors || message.erros || message.Errors || message.Erros;
    if (Array.isArray(errorArray)) {
        const mensagens = errorArray
            .map(e => e.mensagem || e.Mensagem || e.message || e.Message)
            .filter(Boolean)
            .join('\n');
        return mensagens || JSON.stringify(message, null, 2);
    }

    const msg = message.mensagem || message.Mensagem || message.message || message.Message;
    if (msg) {
        return msg;
    }

    return JSON.stringify(message, null, 2);
}

const notificationHelper = (ui) => ({
    showError: (message, title) => {
        ui.ShowError(title, processMessage(message));
    },

    showAlert: (message, title) => {
        ui.ShowAlert(title, processMessage(message));
    },

    showSuccess: (message, title) => {
        ui.ShowSuccess(title, processMessage(message));
    },

    processMessage,
    ui
});

export default notificationHelper;